
  <ng-container *ngIf="data">
    <p>{{data.message}}</p>
  </ng-container>
